var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"prview-content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.notify.title))]),_c('div',{staticClass:"author"},[_vm._v(_vm._s(_vm.notify.createTime))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.notify.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }